<template>
  <div class="page-loading" :class="pageLoading ? 'page-loading--active': ''">
    <div v-if="pageLoading" class="spinner" />
    <session-timeout-modal />
    <router-view></router-view>
  </div>
</template>

<script>
import SessionTimeoutModal from '@/components/partials/SessionTimeoutModal.vue'

import axios from 'axios';
import {mapGetters} from "vuex";
import {api} from "@/store/store";

export default {
  props: {

  },
  components: {
    SessionTimeoutModal
  },
  methods: {
    
  },
  ...mapGetters({
      answers: 'flattenedAnswers',
  }),
  mounted () {
    if ( !this.$route.params.session_id ) {
      // get uuid from backend
      this.$store.dispatch('getUUID')
        .then(response => {

          // Restore-able fields from query params

          // "vehicle_confirm_driver": "new-driver",
          // "vehicle_confirm_driver_gender": "male",
          // "vehicle_confirm_licence": "full",
          // "vehicle_confirm_driver_claim_count": "2",
          // "vehicle_confirm_claim_count_twelve_months_group": [
          //   {
          //     "vehicle_confirm_driver_claims_two_or_more_last_twelve_months": "no"
          //   }
          // ]

          if ( this.$route.query.reseller ) {
            // Use the backend to set the reseller cookie
            axios.post(
              api.url + api.version + 'vehicle/reseller', { reseller: this.$route.query.reseller }
            )
            .then(response => {
              console.log(response);
            })
            .catch(error => {
              
            });

          }

          if ( this.$route.query.plate ) {            
            this.$store.commit('setAnswer',{
              step: 'Vehicle.Plate',
              answer: 'vehicle_plate',
              value: this.$route.query.plate.toUpperCase()
            });
          }

          if ( this.$route.query.start_date ) {
            // check this date is still current or in the future
            // don't set the date explicitly if it's today or in the past
            // (or greater than 30 days in the future)
            // will default to today if no answer assigned

            let date_parts = this.$route.query.start_date.split('-');
            let start_date = new Date(date_parts[2], date_parts[1] - 1, date_parts[0]);

            let max_date = new Date();
            max_date.setDate(max_date.getDate() + 30 - 1);

            if ( start_date >= new Date() && start_date <= max_date ) {
              this.$store.commit('setAnswer',{
                step: 'Vehicle.Confirm',
                answer: 'vehicle_confirm_insurance_start',
                value: this.$route.query.start_date.replaceAll('-','/')
              });
            }
          }

          this.$store.commit('setAnswer',{
            step: 'Vehicle.Confirm',
            answer: 'vehicle_confirm_driver',
            value: 'new-driver'
          });

          if ( this.$route.query.gender ) {
            this.$store.commit('setAnswer',{
              step: 'Vehicle.Confirm',
              answer: 'vehicle_confirm_driver_gender',
              value: ( this.$route.query.gender == 'm' ? 'male' : this.$route.query.gender == 'f' ? 'female' : '' )
            });
          }

          if ( this.$route.query.licence ) {
            this.$store.commit('setAnswer',{
              step: 'Vehicle.Confirm',
              answer: 'vehicle_confirm_licence',
              value: this.$route.query.licence
            });
          }

          if ( this.$route.query.claim_count ) {
            this.$store.commit('setAnswer',{
              step: 'Vehicle.Confirm',
              answer: 'vehicle_confirm_driver_claim_count',
              value: this.$route.query.claim_count
            });

            this.$store.commit('setAnswer',{
              step: 'Vehicle.Confirm',
              answer: 'vehicle_confirm_claim_count_twelve_months_group',
              value: { "vehicle_confirm_driver_claims_two_or_more_last_twelve_months": "no" }
            });
          }

          this.$router.push( { name: 'Vehicle.Plate', query: { 'restore': this.$route.query.reseller ?? 'true' }, params: { session_id: this.$store.state.session_id } } );
        }, error => {
          if( error === 'login_required' ){
            window.location = "/app/login";
          } else {
            // Need to show a generic error, and somehow report the real error back to the site-owners to understand why
            console.error('No valid UUID error on Vehicle Restore', error); // this will trigger sentry

            // TODO - show client-facing error
          }
        })
      return false;
    }
  },
  computed: {
    pageLoading () {
      return this.$store.state.pageLoading;
    }
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="scss">
  
</style>